import React from 'react'
import { connect } from 'react-redux'
import { func, bool, string } from 'prop-types'
import DownloadTypes from './DownloadTypes'
import { toggleDownloads } from '../../../../store/Actions/UiActions'
import '../SubTypeMenu/styles/SubTypeMenu.css'
import { Segment, List } from 'semantic-ui-react'

const downloadsStyle = {
  position: 'absolute',
  listStyle: 'none',
  backgroundColor: 'white',
  zIndex: 100,
  left: '65%',
  top: '30%',
}

const Downloads = ({ showDownloads, toggleDownloads, theme }) =>
  showDownloads && (
    <Segment.Group
      raised
      style={downloadsStyle}
      onMouseLeave={() => toggleDownloads(false)}
    >
      <Segment style={{ padding: '2px' }}>
        <List selection divided verticalAlign="middle">
          <DownloadTypes theme={theme} />
        </List>
      </Segment>
    </Segment.Group>
  )

Downloads.propTypes = {
  showDownloads: bool.isRequired,
  theme: string.isRequired,
  toggleDownloads: func.isRequired,
}

const mapStateToProps = ({ ui, spi }) => ({
  showDownloads: ui.showDownloads,
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  toggleDownloads: value => dispatch(toggleDownloads(value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Downloads)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/Downloads/index.jsx